<!-- 需求提报 -->
<template>
  <div>
    <!-- 搜索 -->
    <div class="container">
      <e-search
        :data="listQuery"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        :width="{ labelWidth: 90, itemWidth: 220 }"
        @handleFilter="handleQuery"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <!-- 操作按钮 -->
    <div class="container">
      <div class="handle-wrapper">
        <eui-btn type="secondary" @click="goCreateRe({})">创建需求</eui-btn>
      </div>
      <eTableList
        :table-data="tableData"
        :table-label="tableLabel"
        :index-show="true"
      >
        <template #purchaseDemandCode="tData">
          <eui-btn
            type="link"
            font-size="12px"
            @click="goDetail(tData.scope.row.purchaseDemandId)"
          >
            {{ tData.scope.row.purchaseDemandCode }}
          </eui-btn>
        </template>
        <template #purchaseDemandStatus="{ scope }">
          <span>{{
            getPurchaseDemandStatus(scope.row.purchaseDemandStatus)
          }}</span>
        </template>
        <template #handle="{ scope }">
          <eui-btn
            type="link"
            font-size="12px"
            v-if="
              scope.row.purchaseDemandStatus === 0 ||
              scope.row.purchaseDemandStatus === 3 ||
              scope.row.purchaseDemandStatus === 4
            "
            @click="goCreateRe(scope.row)"
          >
            修改
          </eui-btn>
          <eui-btn
            type="link"
            font-size="12px"
            v-if="
              scope.row.purchaseDemandStatus === 1 ||
              scope.row.purchaseDemandStatus === 2 ||
              scope.row.purchaseDemandStatus === 3
            "
            @click="openAuditRecordDia(scope.row)"
          >
            审核记录
          </eui-btn>
          <eui-btn
            type="link"
            font-size="12px"
            v-if="
              scope.row.purchaseDemandStatus === 0 ||
              scope.row.purchaseDemandStatus === 4
            "
            @click="openDia('delVisible', scope.row)"
          >
            删除
          </eui-btn>
        </template>
      </eTableList>
      <div class="pagination">
        <el-pagination
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 删除弹窗 -->
    <prompt-modal
      :prompt-modal-visible="delVisible"
      :footer="true"
      @close="closeDia('delVisible')"
    >
      <div slot="title" class="prompt-modal-title">
        <p>删除操作</p>
      </div>
      <div slot="content" class="prompt-modal-content">
        <h4>删除后不可恢复，确认删除吗?</h4>
      </div>
      <div slot="footer">
        <el-button class="btn-80-30" @click="closeDia('delVisible')"
          >关闭</el-button
        >
        <el-button
          v-prevent-re-click
          class="btn-80-30-primary"
          type="primary"
          @click="handleDel"
        >
          删除
        </el-button>
      </div>
    </prompt-modal>

    <!-- 审核记录弹窗 -->
    <audit-record
      :audit-record-visible.sync="auditRecordVisible"
      :row="auditRecordRow"
    />

    <!-- 审批提交 -->
    <audit-info
      :audit-info-visible.sync="auditInfoVisible"
      :is-audit="false"
      :row="paramsRow"
      @submitApprove="submitApprove"
    />

    <!-- 选择审批流弹窗 -->
    <approve
      :show-audit-mask.sync="showAuditMask"
      :approval-list="approvalList"
      @getApprovalChain="getApprovalChain"
    />
  </div>
</template>
<script>
// 删除弹窗
import Api from '@/modules/projectA/api/purchase';
import PromptModal from '@/modules/projectA/components/common/promptModal';
import AuditRecord from '../components/auditRecord.vue';
import AuditInfo from '../components/auditInfoDia.vue';
import Approve from '../components/approveDia.vue';

// 删除弹窗

import mixins from '../components/mixins';
import { tableLabel, fieldList, listTypeInfo } from './componentsData.js';
// 需求计划状态 0:新建 1:待审核 2:审核通过 3:审核驳回
const purchaseDemandStatusList = {
  0: '新建', // 已保存
  1: '待审核', // 有
  2: '审核通过', // 有
  3: '审核驳回', // 有
  4: '退回',
};
export default {
  components: {
    PromptModal,
    AuditRecord,
    AuditInfo,
    Approve,
    /* SupplierPrice */
  },
  mixins: [mixins],
  data() {
    return {
      tableLabel,
      fieldList,
      listTypeInfo,
      showAuditMask: false,
      approvalList: [],
      approvalChain: {},
      // 审批流

      auditInfoVisible: false,
      // 审批信息

      supplierPriceVisible: false,
      supplierPriceRow: {},

      auditRecordRow: {},
      auditRecordVisible: false,
      productDetail: {},
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        purchaseDemandCode: '',
        purchaseDemandName: '',
        endTime: '',
        startTime: '',
        purchaseDemandStatus: '',
        createTime: null,
      },
      total: 0,
      cloneListQuery: {},
      tableData: [],
      // 删除
      delVisible: false,
      paramsRow: {},
      companyId: '',
      workflowDefinitionId: '',
    };
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.USERINFO;
    },
  },
  watch: {
    mall_userInfo: {
      immediate: true,
      handler(newVal) {
        this.userInfo = newVal;
        if (newVal.companyId) {
          this.companyId = newVal.companyId;
        }
      },
    },
  },
  created() {
    this.cloneListQuery = this.$options.data().listQuery;
    this.getList(this.listQuery);
  },
  mounted() {},
  methods: {
    //
    getPurchaseDemandStatus(status) {
      // console.log(status, 'valval');
      const { purchaseDemandStatusList } = this.listTypeInfo;
      const { name } =
        purchaseDemandStatusList.find((item) => {
          return item.id === status;
        }) || {};
      return name;
    },
    // 审批提交
    async submitApprove(val) {
      try {
        const params = {
          contents: val,
          purchaseDemandId: this.paramsRow.purchaseDemandId,
          workflowDefinitionId: '',
        };
        if (this.workflowDefinitionId) {
          params.workflowDefinitionId = this.workflowDefinitionId;
        }

        const res = await Api.commitPurchaseDemand(params);
        if (res.code === '200') {
          // this.$message.success("提交审核成功");
          this.handleQuery();
          this.closeDia('auditInfoVisible');
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 获取审批信息
    async getApprovalList() {
      try {
        const params = {
          auditType: 3,
        };
        const res = await Api.approveList(params);
        this.approvalList = res.data;
        // this.approvalList = [];
        if (this.approvalList.length !== 0) {
          // 有审批流
          this.showAuditMask = true;
        } else {
          // 无审批流
          this.auditInfoVisible = true;
        }
      } catch (err) {
        console.log(err);
      }
    },
    getApprovalChain(val) {
      this.workflowDefinitionId = val;
      this.auditInfoVisible = true;
    },
    openApproval(row) {
      this.paramsRow = row;
      this.getApprovalList();
    },

    // 打开审核记录弹窗
    openAuditRecordDia(row) {
      this.auditRecordVisible = true;
      this.auditRecordRow = { ...row };
    },

    // 删除操作
    async handleDel() {
      const params = { purchaseDemandId: this.paramsRow.purchaseDemandId };
      const res = await Api.deletePurchaseDemand(params);
      if (res.code === '200') {
        this.closeDia('delVisible');
        this.listQuery = { ...this.cloneListQuery };
        this.getList(this.listQuery);
      }
    },

    // 获取列表数据
    async getList(params) {
      this.tableLoading = true;
      await Api.queryPurchaseDemand(params).then((res) => {
        this.tableLoading = false;
        if (res.code === '200') {
          const { data } = res;
          this.tableData = [...data?.records];
          this.total = data?.total;
        }
      });
    },

    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },

    // 更改条数
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },

    // 重置
    handleReset() {
      this.listQuery = { ...this.cloneListQuery };
      this.getList(this.listQuery);
    },

    // 搜索
    handleQuery(val) {
      console.log(val);
      if (val.createTime?.length) {
        val.startTime = val.createTime[0];
        val.endTime = val.createTime[1];
      } else {
        val.startTime = '';
        val.endTime = '';
        val.createTime = [];
      }
      this.listQuery = { ...val, pageNum: 1 };
      this.getList(this.listQuery);
    },

    // 修改/新增
    goCreateRe(row = {}) {
      const { purchaseDemandId = '', purchaseDemandStatus = '' } = row;
      this.$router.push({
        path: `/demand/demandManage/createDemand`,
        query: purchaseDemandId
          ? { purchaseDemandId, purchaseDemandStatus }
          : {},
      });
    },

    goDetail(purchaseDemandId) {
      this.$router.push({
        path: `/demand/demandManage/demandDetail`,
        query: { purchaseDemandId },
      });
    },

    // 打开弹窗
    openDia(type, row) {
      this[type] = true;
      this.paramsRow = { ...row };
    },

    // 关闭弹窗
    closeDia(type) {
      this[type] = false;
      this.paramsRow = {};
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.prompt-modal-title {
  display: flex;
  height: 40px;
  padding-left: 20px;
  align-items: center;

  img {
    width: 18px;
    height: 18px;
    margin-right: 10px;
    vertical-align: middle;
  }

  p {
    font-size: 14px;
    font-weight: 500;
    color: $c3;
    line-height: 14px;
  }
}

.prompt-modal-content {
  > h4 {
    font-weight: 500;
    color: $c3;
    margin-bottom: 5px;
  }
}
</style>
